import { render, staticRenderFns } from "./AuthCodeModalSection.vue?vue&type=template&id=53dd3a03"
import script from "./AuthCodeModalSection.vue?vue&type=script&lang=js"
export * from "./AuthCodeModalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports